export default (() => {

    const global = { 
        elements: {},
        pageData: {}, 
    };

    const defaultErrorLogEndpoint = 'Apply/LogTinkIframeError';
    
    const defaultPaymentCancelledUri = '/Deposit/OpenBankingPaymentCancelled/';

    function initialiseOpenBankingDeposit (){
        global.elements = _getCatchedElements();
        global.pageData = _getPageData();

        _bindEvents();
    }

    function _getCatchedElements(){
        return {
            iframe: document.querySelector('[data-iframe]'),
            openBankingWrapper: document.querySelector('[data-open-banking-wrapper]'),
            loadingSpinner: document.querySelector('[data-loader]'),
            continueOpenBankingPaymentButton: document.querySelector('[data-js=continue-open-banking-payment]'),
            requestVerificationToken: document.querySelector('input[name=__RequestVerificationToken]'),
            transaction: document.querySelector('[data-transaction-id]'),
            instructionsContainer: document.querySelector('[data-open-banking-instructions]'),
            iframeContainer: document.querySelector('[data-payment-container]')
        };
    }

    function _getPageData(){

        let paymentId = '',
            paymentCancelledUri = '', 
            pollingUrlParts = [];

        if(global.elements.openBankingWrapper.dataset.pollingUrl){
            const cancelledUri = global.elements.openBankingWrapper.dataset.cancelledUrl ?? defaultPaymentCancelledUri;

            pollingUrlParts = global.elements.openBankingWrapper.dataset.pollingUrl.split('/');

            paymentId = pollingUrlParts[pollingUrlParts.length - 1];
            paymentCancelledUri = cancelledUri + paymentId;
        }

        let pageData = {
            pollingAttempts: 0, 
            pollingStarted: false,
            pollingUrlParts,
            paymentCancelledUri,
            paymentId, 
            iframeLoaded: false,
            statusUrl: global.elements.openBankingWrapper.dataset.updateStatusUrl,
            pollingUrl:  global.elements.openBankingWrapper.dataset.pollingUrl,
            pollingInterval: global.elements.openBankingWrapper.dataset.pollingInterval,
            token: global.elements.requestVerificationToken.value,
            transactionId: global.elements.transaction.dataset.transactionId,
            errorLogEndpoint: global.elements.iframe.dataset.logTinkErrorEndpoint ?? defaultErrorLogEndpoint
        };

        return pageData;
    }

    function _bindEvents(){

        global.elements.continueOpenBankingPaymentButton.addEventListener('click',_showOpenBankingIframe);

        global.elements.iframe.addEventListener('load',_setIframeLoaded);

        window.addEventListener('message', _handlePostMessage, false);
    }

    function _showOpenBankingIframe(){

        const instructionsContainer = global.elements.instructionsContainer;
        const iframeContainer = global.elements.iframeContainer;
        const depositOpenBanking =  global.elements.openBankingWrapper;

        depositOpenBanking.classList.add('deposit__open-banking__heading--hidden');
        iframeContainer.classList.toggle('show', true);
        instructionsContainer.classList.toggle('show', false);
        window.scrollTo({
            top: 0, 
            behavior: 'smooth' 
        });
    }

    function _setIframeLoaded(){

        if (!global.pageData.iframeLoaded) {
            global.elements.loadingSpinner.classList.toggle('show', false);
            global.elements.iframe.classList.toggle('show', true);
        }
    }

    function _handlePostMessage(event) {
        try {

            const { 
                type, 
                data,
                error
            } = JSON.parse(event.data);
            
            if (type === 'application-event') {
                _updatePaymentStatus(data.event);
            }

            if (error !== undefined && error.status === 'USER_CANCELLED') {            
                window.location.href = global.pageData.paymentCancelledUri;

                return;
            }

            if(type === 'error'){
                _sendError(error);
            }   

            if (!global.pageData.pollingStarted && 
                ((type === 'application-event' && (data.event === 'AUTHENTICATION_SUCCESSFUL' || data.event === 'PAYMENT_SUCCESSFUL')) || type === 'payment_request_id')) {

                global.pageData.pollingStarted = true;
                global.elements.iframe.classList.toggle('show', false);
                global.elements.loadingSpinner.classList.toggleClass('show', true);
                _attemptOpenBankingRedirectViaPolling();
            }

        } catch (e) {
            console.log('Error handling post message from iframe.');
        }
    }

    function _updatePaymentStatus(eventStatus) {

        const config = {
            contentType: 'application/x-www-form-urlencoded; charset=utf-8',
            url: global.pageData.statusUrl,
            antiForgeryToken:  global.pageData.token,
            data: {
                __RequestVerificationToken: global.pageData.token,
                paymentStatus: eventStatus,
                transactionID: global.pageData.transactionId
            }
        };

        wealthify.request.send(config).catch(error => {
            _sendError(error);
        });

    }

    function _sendError(error){
        const config = {
            data: {
                status: error.status,
                message: error.message,
                reason: error.reason,
            },
            contentType: 'application/json',
            url: global.pageData.errorLogEndpoint,
        };

        wealthify.request.send(config);
    }

    function _attemptOpenBankingRedirectViaPolling() {
        // Increment the polling attempts
        global.pageData.pollingAttempts++;

        // Make the request
        const config = {
            url: `${global.pageData.pollingUrl}?attempt=${global.pageData.pollingAttempts}`,
            method: 'GET'
        };

        wealthify.request.send(config)
            .then((data) => {
                if (data.redirectUrl != null) {
                    window.location.href = data.redirectUrl;
                } else {
                    _retryOpenBankingRedirect();
                }
            })
            .catch(() => {
                // Ignore the error and keep trying
                _retryOpenBankingRedirect();
            });
    }

    function _retryOpenBankingRedirect () {
        setTimeout(_attemptOpenBankingRedirectViaPolling, global.pageData.pollingInterval);
    }
    
    return { initialiseOpenBankingDeposit };
    
})();